import React from 'react';

import { MDText } from 'i18n-react';

import { InfoBox } from '@motorway/mw-highway-code/alpha';
import { INFOBOX_VARIANT } from '@motorway/mw-highway-code/enums';

import LocalTexts from './KeeperAttentionInfoBox.texts.json';

import styles from './KeeperAttentionInfoBox.module.scss';

const LocalT = new MDText(LocalTexts);

export const KeeperAttentionInfoBox = () => (
  <div className={styles.component}>
    <InfoBox content={LocalT.translate('content')} variant={INFOBOX_VARIANT.INFO} />
  </div>
);
